import React, { FC } from 'react';
import { ToggleButtonGroup as MuiToggleButtonGroup } from '@mui/material';
import { ToggleButtonGroupProps } from '@mui/material/ToggleButtonGroup';
import { useTheme, Theme } from '@mui/material/styles';
import styled from 'styled-components';

type StyledToggleButtonGroupProps = ToggleButtonGroupProps & { theme: Theme };

const StyledToggleButtonGroup = styled(MuiToggleButtonGroup)<StyledToggleButtonGroupProps>`
  --color: ${({ color, theme }) =>
    !color || color === 'primary'
      ? theme.palette.primary.main
      : color === 'secondary'
        ? theme.palette.secondary.main
        : color};

  .MuiToggleButton-root.Mui-selected {
    &:hover {
      background-color: var(--color);
    }

    background-color: var(--color);
    color: white;
  }
`;

export const ToggleButtonGroup: FC<ToggleButtonGroupProps> = props => {
  const theme = useTheme();
  return <StyledToggleButtonGroup {...props} theme={theme} />;
};

export type { ToggleButtonGroupProps };
